import React, { useState } from "react";
import Select from "react-select";

import "./leavetype.css";

const SelectMenu = ({ value, onChange }) => {
  const options = [
    {
      value: "no-icon",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-umbrella"></i>
        </div>
      ),
    },
    // 🌴 Annual Leave / Vacation
    {
      value: "bi-airplane",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-airplane"></i>
        </div>
      ),
    },
    {
      value: "bi-sun",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-sun"></i>
        </div>
      ),
    },
    // 🤒 Sick Leave / Medical
    {
      value: "bi-heart-pulse",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-heart-pulse"></i>
        </div>
      ),
    },
    {
      value: "bi-thermometer-half",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-thermometer-half"></i>
        </div>
      ),
    },
    {
      value: "bi-hospital",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-hospital"></i>
        </div>
      ),
    },
    // 👨‍👩‍👧 Family / Maternity
    {
      value: "bi-house-heart",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-house-heart"></i>
        </div>
      ),
    },
    {
      value: "bi-person-heart",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-person-heart"></i>
        </div>
      ),
    },
    // 🏢 Work / Business
    {
      value: "bi-briefcase",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-briefcase"></i>
        </div>
      ),
    },
    {
      value: "bi-building",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-building"></i>
        </div>
      ),
    },
    {
      value: "bi-laptop",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-laptop"></i>
        </div>
      ),
    },
    // 📚 Education / Training
    {
      value: "bi-mortarboard",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-mortarboard"></i>
        </div>
      ),
    },
    {
      value: "bi-book",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-book"></i>
        </div>
      ),
    },
    // 🎉 Holidays / Events
    {
      value: "bi-gift",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-gift"></i>
        </div>
      ),
    },
    {
      value: "bi-calendar-event",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-calendar-event"></i>
        </div>
      ),
    },
    {
      value: "bi-star",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-star"></i>
        </div>
      ),
    },
    // ⚠️ Emergency
    {
      value: "bi-exclamation-triangle",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-exclamation-triangle"></i>
        </div>
      ),
    },
    {
      value: "bi-lightning",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-lightning"></i>
        </div>
      ),
    },
    {
      value: "bi-clock",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-clock"></i>
        </div>
      ),
    },
    // ☕ Miscellaneous
    {
      value: "bi-cup-hot",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-cup-hot"></i>
        </div>
      ),
    },
    {
      value: "bi-tree",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-tree"></i>
        </div>
      ),
    },
    {
      value: "bi-emoji-smile",
      label: (
        <div style={{ cursor: "pointer" }}>
          <i className="bi bi-emoji-smile"></i>
        </div>
      ),
    },
  ];

  React.useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    const tooltipList = [...tooltipTriggerList].map(
      (tooltipTriggerEl) => new window.bootstrap.Tooltip(tooltipTriggerEl)
    );
  }, []);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div
      style={{
        cursor: "pointer",
        position: "relative",
        zIndex: isMenuOpen ? 99999 : 1000,
        width: "90px",
      }}
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      data-bs-custom-class="custom-tooltip"
      data-bs-title="Add Icon"
    >
      <Select
        value={options.find((option) => option.value === value) || options[0]}
        onChange={(selectedOption) => onChange(selectedOption.value)}
        onMenuOpen={() => setIsMenuOpen(true)}
        onMenuClose={() => setIsMenuOpen(false)}
        components={{
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
        }}
        className="select-menu text-center"
        placeholder="No icon"
        options={options}
        isSearchable={false}
        styles={{
          control: (provided) => ({
            ...provided,
            minHeight: "40px",
            maxHeight: "40px",
            height: "40px",
            border: "1px solid #dee2e6",
            borderRadius: "8px",
            boxShadow: "none",
            "&:hover": {
              borderColor: "#667eea",
            },
          }),
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
              ? "#667eea"
              : state.isFocused
                ? "#f8f9fa"
                : "white",
            color: state.isSelected ? "white" : "#333",
            padding: "8px 4px",
            margin: 0,
            cursor: "pointer",
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }),
          menu: (provided) => ({
            ...provided,
            border: "1px solid #dee2e6",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            zIndex: 99999,
            position: "absolute",
            minWidth: "90px",
            width: "90px",
            margin: 0,
            padding: 0,
          }),
          menuList: (provided) => ({
            ...provided,
            padding: "4px 0",
            margin: 0,
          }),
          singleValue: (provided) => ({
            ...provided,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }),
          menuPortal: (provided) => ({
            ...provided,
            zIndex: 99999,
          }),
        }}
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
    </div>
  );
};

export default SelectMenu;
